export default "__VITE_ASSET__8920dfb4__"